import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [msg, setMsg] = useState("Confirming your payment…");
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { setMsg("Missing session id."); return; }
    let cancelled = false;
    let attempts = 0;
    async function poll() {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        if (data.payment_status === "paid" && data.activation_token) {
          nav(`/set-password/${data.activation_token}`, { replace: true });
          return;
        }
        if (data.payment_status === "paid") {
          setMsg("Payment received. Redirecting…");
          setTimeout(() => nav("/login", { replace: true }), 1500);
          return;
        }
        if (data.payment_status === "expired" || data.payment_status === "failed") {
          setMsg("Payment was not completed. Please try again.");
          setTimeout(() => nav("/join", { replace: true }), 2500);
          return;
        }
      } catch {/* keep polling */}
      attempts += 1;
      if (attempts > 30) { setMsg("Still waiting… please refresh in a moment."); return; }
      setTimeout(poll, 2000);
    }
    poll();
    return () => { cancelled = true; };
  }, [sid, nav]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="payment-success">
      <div className="max-w-md text-center">
        <div className="label-eyebrow text-primary">Payment</div>
        <h1 className="mt-4 font-display text-4xl md:text-5xl uppercase leading-[0.95]">You're in.</h1>
        <p className="mt-6 text-foreground/75" data-testid="payment-status-msg">{msg}</p>
        <div className="mt-8 flex justify-center">
          <div className="w-10 h-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        </div>
      </div>
    </div>
  );
}
